import LockResetIcon from "@mui/icons-material/LockReset";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Box,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  TextFieldVariants,
} from "@mui/material";
import { TextFieldProps } from "@mui/material/TextField";
import { forwardRef, useState } from "react";

type IPasswordFieldProps = TextFieldProps<TextFieldVariants> & {
  onResetPassword?: (pass: string) => void;
};

export const PasswordField = forwardRef<HTMLInputElement, IPasswordFieldProps>(
  (props, ref) => {
    const { onResetPassword, ...rest } = props;
    const [showPassword, setShowPassword] = useState(false);
    const handleMouseDownPassword = (
      event: React.MouseEvent<HTMLButtonElement>,
    ) => {
      event.preventDefault();
    };
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    return (
      <Stack
        direction="row"
        spacing={1}
        sx={{
          width: "100%",
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          ref={ref}
          {...rest}
          type={showPassword ? "text" : "password"}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
        {onResetPassword && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
            }}
          >
            <IconButton>
              <LockResetIcon />
            </IconButton>
          </Box>
        )}
      </Stack>
    );
  },
);

PasswordField.displayName = "PasswordField";
